module.exports = __webpack_public_path__ + "static/media/money-bill@2x.9268fb4b.jpg";